import { RendezVousPostFormationNavigationLarge } from "@/components/formation/navigation";
import { Presentation } from "lucide-react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function CompletedPage(){
    const {t} = useTranslation("common");
    return <div className="max-w-2xl flex flex-col items-center justify-center mx-auto">
        <div className="flex items-center justify-center mb-4 w-full">
            <Presentation className="w-14 h-14 mb-4 inline text-orange-500" />
        </div>
        <h1 className="text-4xl font-bold mb-4">{t("tutor-inscription-status.formation.completed.title")}</h1>
        <p className="mb-4">{t("tutor-inscription-status.formation.completed.description")}</p>

        <RendezVousPostFormationNavigationLarge/>
        <div className="mt-3 w-full">
            <Link to="/" className="underline  text-orange-500 hover:text-orange-500/80 text-left">
            {t("tutor-inscription-status.formation.completed.button")}
        </Link>
        </div>
    </div>
}